import rollbarLogger from './rollbar-logger/rollbar-logger';

/* istanbul ignore file */
class Logger {
  error(err, errorMsg = null, additionalInfo = null) {
    rollbarLogger.error(err, errorMsg, additionalInfo);

    if (process.env.NODE_ENV === 'test') return;

    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.info('Logger.error');

      if (!!errorMsg) {
      // eslint-disable-next-line no-console
        console.error(`errorMsg: ${ errorMsg }`);
      }

      // eslint-disable-next-line no-console
      console.error(err);
    }

    if (!!additionalInfo) {
      // eslint-disable-next-line no-console
      console.info(additionalInfo);
    }
  }
}

export default new Logger();
